export const Devices = {
    mobile: "mobile",
    desktop: "desktop"
};

export const MIN_WIDTH_DESKTOP = 768;
